// actions
import * as actions from './actions';

const initialState = {
  available: true,
  chakras: [],
  questions: [],
  reading: null,
  readingEvaluated: false,
  leadCaptured: false,
  error: null,
  submitError: null,
  loading: false,
  initial: false,
};

export default function chakrasReducer(state = initialState, action) {
  switch (action.type) {
    // Availability
    case actions.FETCH_CHAKRA_AVAILABILITY_REQUEST:
      return { ...state, loading: true, error: null };

    case actions.FETCH_CHAKRA_AVAILABILITY_SUCCESS:
      return { ...state, available: action.payload.available, loading: false, initial: true, error: null };

    case actions.FETCH_CHAKRA_AVAILABILITY_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Questionnaire
    case actions.FETCH_CHAKRA_QUESTIONNAIRE_REQUEST:
      return { ...state, loading: true, error: null };

    case actions.FETCH_CHAKRA_QUESTIONNAIRE_SUCCESS:
      return { ...state, questions: action.payload.questions, loading: false, error: null };

    case actions.FETCH_CHAKRA_QUESTIONNAIRE_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Submit
    case actions.SUBMIT_CHAKRA_QUESTIONNAIRE_REQUEST:
      return { ...state, loading: true, submitError: null, reading: null };

    case actions.SUBMIT_CHAKRA_QUESTIONNAIRE_SUCCESS:
      return { ...state, reading: action.payload.reading, loading: false, submitError: null };

    case actions.SUBMIT_CHAKRA_QUESTIONNAIRE_FAILURE:
      return { ...state, loading: false, submitError: action.payload };

    // All chakras (catalog)
    case actions.FETCH_ALL_CHAKRAS_REQUEST:
      return { ...state, loading: true, error: null };

    case actions.FETCH_ALL_CHAKRAS_SUCCESS:
      return { ...state, chakras: action.payload.chakras, loading: false, error: null };

    case actions.FETCH_ALL_CHAKRAS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    // Like
    case actions.SET_CHAKRA_READING_LIKE_REQUEST:
      return { ...state };

    case actions.SET_CHAKRA_READING_LIKE_SUCCESS:
      return { ...state, readingEvaluated: true };

    case actions.SET_CHAKRA_READING_LIKE_FAILURE:
      return { ...state };

    // Lead capture
    case actions.CAPTURE_CHAKRA_LEAD_REQUEST:
      return { ...state };

    case actions.CAPTURE_CHAKRA_LEAD_SUCCESS:
      return { ...state, leadCaptured: true };

    case actions.CAPTURE_CHAKRA_LEAD_FAILURE:
      return { ...state };

    // Reset
    case actions.RESET_CHAKRAS:
      return { ...initialState };

    default:
      return state;
  }
}
